// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { spicy as _spicy } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the spicy chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 88882
 * Chain Name: Chiliz Spicy Testnet
 * Default Block Explorer: http://spicy-explorer.chiliz.com
 * Default RPC URL: https://spicy-rpc.chiliz.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { spicy } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: spicy,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const spicy = createCommon({
	..._spicy,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
